var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EssaysContent',{attrs:{"essayurl":_vm.essayurl,"directorurl":_vm.directorurl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }